export default "__VITE_ASSET__CbQB_P9G__"